import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { GitlabConnector } from '../../connector';

export const GitlabService = IntegrationService.make({
  connector: GitlabConnector,
  name: Integration_Service_Names_Enum.Gitlab,
});
